"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _MobileFiltersDrawerModule = _interopRequireDefault(require("./MobileFiltersDrawer.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Mobile Filters Drawer
 * Foodbomb Drawer for displaying content on mobile
 *
 * ## PropTypes:
 * ```js
 * MobileFiltersDrawer.propTypes = {
 *   isOpen: PropTypes.bool,
 *   onClose: PropTypes.func.isRequired,
 *   className: PropTypes.string,
 *   classes: PropTypes.shape({
 *     root: PropTypes.string,
 *     paper: PropTypes.string,
 *   }),
 *   children: PropTypes.node,
 * };
 * ```
 */
var MobileFiltersDrawer = function MobileFiltersDrawer(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      className = _ref.className,
      classes = _ref.classes,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["isOpen", "onClose", "className", "classes", "children"]);

  var drawerClasses = [_MobileFiltersDrawerModule.default.MobileFiltersDrawer];
  drawerClasses.push(className);
  var paperClasses = [_MobileFiltersDrawerModule.default.MobileFiltersDrawer__paper];
  var rootClasses = [];

  if (classes) {
    paperClasses.push(classes.paper);
    rootClasses.push(classes.root);
  }

  return /*#__PURE__*/_react.default.createElement(_core.Drawer, _extends({
    open: isOpen,
    anchor: "left",
    onClose: onClose,
    className: drawerClasses.join(' '),
    classes: {
      root: rootClasses.join(' '),
      paper: paperClasses.join(' ')
    }
  }, props), children);
};

MobileFiltersDrawer.propTypes = {
  isOpen: _propTypes.default.bool,
  onClose: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    paper: _propTypes.default.string
  }),
  children: _propTypes.default.node
};
var _default = MobileFiltersDrawer;
exports.default = _default;

//# sourceMappingURL=MobileFiltersDrawer.js.map